import './headerFullWidth.css';
export var fullWidthStyles = "f1mvwx8f";
export var ltrStyles = "l1illq4";
export var rtlStyles = "r16k3x6k";